<template>
  <div v-show="!hidden" role="tabpanel" :class="['tab-pane', {'active': active}, bodyClass]" :id="id">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String
    },
    title: {
      type: String
    },
    icon: {
      type: String
    },
    iconPrefix: {
      type: String,
      default: 'fa'
    },
    hidden: {
      type: Boolean,
      default: false
    },
    badge: {},
    badgeColor: {
      // primary, danger, warning, info, success
      type: String,
      default: 'danger'
    },
    bodyClass: {}
  },
  computed: {
    active() {
      return this.$parent.isPrintView || ((typeof this.$parent.activeTab == 'string') && this.$parent.activeTab == this.id);
    }
  },
  mounted() {
    if (this.id && typeof this.$parent.registerTab == 'function') {
      this.$parent.registerTab(this);
    }
  }
}
</script>
